import type { AnalyticsProvider } from '../../AnalyticsManager.types'

export enum MixpanelEventMethod {
	TRACK = 'track',
	IDENTIFY_USER = 'identifyUser',
	RESET_USER = 'resetUser',
	SET_USER_PROPERTIES = 'setUserProperties',
	SET_SUPER_PROPERTIES = 'setSuperProperties',
}

export interface MixpanelEventData {
	eventName: string
	method: MixpanelEventMethod
	arguments: [Record<string, unknown>] | [string] | null
}

export interface MixpanelDependency {
	sendEvent: (analyticsProvider: AnalyticsProvider, eventData: MixpanelEventData) => Promise<void>
	isMobileApp: () => boolean
}

export interface MixpanelSDKConfiguration {
	debug?: boolean
	token: string
	track_pageview: boolean
	persistence: 'localStorage' | 'sessionStorage' | 'cookie'
}
